import React, { useCallback, useContext } from 'react'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import ModalContext from 'contexts/ModalContext'

function BedbankMultiRoomLoginCTA() {
  const showModal = useContext(ModalContext)

  const onClick = useCallback(() => {
    showModal(<AccountAccessModal initialMode="join" />)
  }, [showModal])

  return <Sheet padding={20} background="neutral-eight">
    <TextButton kind="primary" onClick={onClick} size="large" fit="full-width">
      Log in to book this offer
    </TextButton>
  </Sheet>
}

export default BedbankMultiRoomLoginCTA
